import { useQuery } from 'react-query';
import { useMemo } from 'react';
import { getAllAdjustmentComments } from 'apis/adjustmentComments.api';

const useGetAllAdjustmentComments = (params, conds = {}) => {
  const { data: adjustmentCommentsData, ...rest } = useQuery(
    ['projectAdjustmentComments', params],
    () => getAllAdjustmentComments(params),
    {
      ...conds,
    }
  );

  const adjustmentComments = useMemo(
    () => adjustmentCommentsData?.data ?? {},
    [adjustmentCommentsData]
  );

  return {
    data: adjustmentComments,
    ...rest,
  };
};

export default useGetAllAdjustmentComments;
